import ee from 'event-emitter'

const Emiter = function () {}

export default ee(Emiter.prototype)

export const types = {
	openAddAdmin: 'openAddAdmin',
	openAddFeedModal: 'openAddFeedModal',
	openAddExpertModal: 'openAddExpertModal',
	openDetailFeedModal: 'openDetailFeedModal',
	openAddTeacherModal: 'openAddTeacherModal',
	openMergeSchoolModal: 'openMergeSchoolModal',
	openMergeTeacherModal: 'openMergeTeacherModal',
	openAddEmployeeModal: 'openAddEmployeeModal',
	openCustomizeMultiModal: 'openCustomizeMultiModal',
	openAddShareholderModal: 'openAddShareholderModal',
	openCheckConfirmAccount: 'openCheckConfirmAccount',
	openCustomizeIncomeModal: 'openCustomizeIncomeModal',
	openCustomizeCompaniesModal: 'openCustomizeCompaniesModal',
	openRejectCompanyCommentModal: 'openRejectCompanyCommentModal',
	openCustomizeSimpleWidgetModal: 'openCustomizeSimpleWidgetModal',
	openAddSchool: 'openAddSchool',
	openAddTeacher: 'openAddTeacher',
	openStudentProfile: 'openStudentProfile',
	openInvoiceChangeData: 'openInvoiceChangeData',
	openInvoiceCancel: 'openInvoiceCancel',
	openEmployeeDetail: 'openEmployeeDetail',
	openShareholderDetail: 'openShareholderDetail',
	refreshEmployeesNavbar: 'refreshEmployeesNavbar',
	openCropperModal: 'openCropperModal',
	// Das Konzept hinter einer Zeile der Skills4Retail-Auswertung, zum Lesen.
	openConceptDetail: 'openConceptDetail',
	// Die eine Rueckfrage der Anwendung (UI/ConfirmDialog), gestellt ueber
	// shared/confirmDialog — nicht von Hand emittieren.
	openConfirmDialog: 'openConfirmDialog',
	// Hinweis auf die Unterstützer:innen-Registrierung nach dem Herunterladen
	// der Teilnahmeurkunde (UI/SupporterInvitationDialog), gerufen über
	// shared/supporterInvitation.
	openSupporterInvitation: 'openSupporterInvitation'
}
